export default __webpack_public_path__ + "static/Swiss721BT-Roman-4142fdd34af051062463b1a7d759bfc1.eot";